/**
 * Reconciling a wallet's own monthly screen against the ledger (spec v2 §12/§26, B3).
 *
 * MoMo reports what the household spent through it, by category, once a month. Some of that
 * spending was already typed in by hand during the month. Posting the reported figure as-is
 * would count those coffees twice — so the entry that closes the month carries only the
 * DIFFERENCE, and this is where the difference is worked out.
 *
 * Pure and total: it decides nothing about the database, it only pairs two lists of numbers
 * that both arrived from somewhere else. `alreadyRecorded` comes from the ledger and is
 * recomputed server-side at confirm time — what happens here is a preview.
 */
export function computeReconciliation(input) {
    const ledgerByCategory = new Map(input.ledgerExpenseByCategory.map((entry) => [entry.categoryId, entry.amount]));
    const rows = input.reportedItems.map((item) => {
        const alreadyRecorded = ledgerByCategory.get(item.categoryId) ?? 0;
        const adjustment = item.reportedAmount - alreadyRecorded;
        return {
            categoryId: item.categoryId,
            reportedAmount: item.reportedAmount,
            alreadyRecorded,
            adjustment,
            isOverRecorded: adjustment < 0,
        };
    });
    const reported = new Set(input.reportedItems.map((item) => item.categoryId));
    return {
        rows,
        totalAdjustment: rows.reduce((sum, row) => sum + row.adjustment, 0),
        unreportedCategoryIds: input.ledgerExpenseByCategory
            .filter((entry) => entry.amount !== 0 && !reported.has(entry.categoryId))
            .map((entry) => entry.categoryId),
    };
}
//# sourceMappingURL=reconciliation.js.map